import appStoreImage from 'img/quota-landing/appStore.png';
import googlePlayImage from 'img/quota-landing/googlePlay.png';
import React, { memo, ReactElement, useCallback, useEffect, useRef } from 'react';
import { toolbarActions } from 'reactApp/appHelpers/toolbarActions';
import { MobileDialog } from 'reactApp/ui/Mobile/MobileDialog/MobileDialog';

import styles from './PayInBrowser.css';
import { sendGa } from './PayInBrowser.helpers';

const MOBILE_URL = 'https://cloud.mail.ru/mobile';
const QUOTA_URL = 'https://cloud.mail.ru/promo/quota';

export interface IProps {
    id: string;
    onOpen(id: string): void;
    onCopy(): void;
    onClose(): void;
    isIOSPromo?: boolean;
    isAndroidPromo?: boolean;
}

export const PayInBrowser = memo(function PayInBrowser(props: IProps): ReactElement | null {
    const { onClose: handleClose, onOpen, onCopy: onCopyUrl, id, isIOSPromo, isAndroidPromo } = props;

    const currentURL = isIOSPromo || isAndroidPromo ? QUOTA_URL : MOBILE_URL;
    const title = (
        <>
            {isIOSPromo ? 'App Store' : 'Google Play'} ограничил
            <br />
            продажу тарифов в России
        </>
    );

    const onCopy = useCallback(() => {
        onCopyUrl();
        toolbarActions.shareLink({ url: currentURL, useNativeShare: false });
        sendGa('copy');
    }, [onCopyUrl]);

    const onClose = useCallback(() => {
        handleClose();
        sendGa('close');
    }, [handleClose]);

    useEffect(() => {
        onOpen(id);
        sendGa('open');
    }, []);

    const ref = useRef<HTMLDivElement>(null);

    return (
        <MobileDialog
            id="pay-in-browser"
            open
            dimmer
            onClose={onClose}
            disableScrolling
            closable
            closeOnDimmerClick
            mod="base"
            topmost
            scrollRef={ref}
        >
            <div className={styles.root} ref={ref}>
                <img src={isIOSPromo ? appStoreImage : googlePlayImage} className={styles.image} />
                <div className={styles.title}>{title}</div>
                <div className={styles.description}>
                    Для оплаты тарифа воспользуйтесь <span>веб-версией</span> Облака
                </div>

                <div className={styles.copyUrl}>
                    <div className={styles.url} onClick={onCopy}>
                        {currentURL}
                    </div>
                </div>
            </div>
        </MobileDialog>
    );
});
